import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import styled, { css } from 'styled-components';
import { ButtonPollingProps, PollingBarProps } from './types';

/**
 *
 *  Stream Content Polling Area
 *
 */

const PollingWrapper = styled.div`
  margin-bottom: 16px;
`;

const ContentWrapper = styled.div`
  border-radius: 3px;
`;

const Container = styled.div`
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;
`;

const PollingHeader = styled.div`
  padding: 10px 20px;
  border-bottom: 1px solid ${color.gainsboro};
`;

const PollingContent = styled.div`
  padding: 20px 23px;
  background: ${color.snow};
`;

const PollingValue = styled.div`
  width: 60px;
`;

const PollingBarWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PollingBar = styled.div.attrs<PollingBarProps>((props) => ({
  width: props.width || '100%',
}))<PollingBarProps>`
  border-radius: 4px;
  height: 40px;
  position: absolute;
  transition: all 0.5s ease;
  width: ${({ width }) => width};

  ${({ fill }) =>
    fill &&
    css`
      background: ${color.bubbles};
    `};
`;

const ButtonPolling = styled(Button)
  .withConfig({
    // @ts-ignore
    shouldForwardProp: (prop) => !['fill'].includes(prop),
  })
  .attrs((props: ButtonPollingProps) => ({
    fill: props.fill,
    margin: '0 0 12px',
    height: '40px',
    block: true,
    padding: 0,
  }))`
  justify-content: flex-start;
  transition: all 0.25s ease;
  border-radius: 3px;
  
  ${({ fill }) =>
    fill &&
    css`
      background: none;
      border-color: transparent;
      border-radius: 3px;
      box-shadow: none;
      /* cursor: default; */
      :hover,
      :focus,
      :active {
        background: none;
        border-color: transparent;
      }
    `}
`;

export {
  ContentWrapper,
  Container,
  PollingContent,
  PollingHeader,
  PollingValue,
  ButtonPolling,
  PollingWrapper,
  PollingBarWrapper,
  PollingBar,
};
